__turbopack_context__.v({
  "enabled": "ScrollableRefinementList-module-scss-module__g8S4va__enabled",
  "scrollableList": "ScrollableRefinementList-module-scss-module__g8S4va__scrollableList",
});
